import React from 'react';
import classNames from 'classnames';

import {
  VisuallyHiddenSpan
} from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import {
  getInternalLinkUrl
} from 'zoomforth_codesbane_viewer/lib/app_actions.js';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const VideoPlaylistItem_ViewerVersion1 = ({
  className,
  title,
  altText,
  uuid,
  thumbnail,
  htmlCaption,
  isSelected,
  children,
  onSelectContentClick
}) => (
  <div
    className={classNames('playlist-item', className, {
      'selected': isSelected,
      [`content-uuid-${uuid}`]: uuid
    })}
    onClick={onSelectContentClick}
  >

    <div className="video-title-section">

      <img
        className="video-thumbnail"
        alt={altText}
        src={thumbnail}
      />

      {
        isSelected &&
        <div className="now-playing">
          Now Viewing
        </div>
      }

      <div className="video-title">
        {title}
      </div>

      <div className="clear"></div>

    </div>

    {
      htmlCaption &&
      <div className="video-caption" dangerouslySetInnerHTML={{ __html:htmlCaption }}></div>
    }

    {children}

  </div>
);

const VideoPlaylistItem_ViewerVersion2 = ({
  playlistIdx,
  uuid,
  title,
  altText,
  children,
  className,
  subpageId,
  thumbnail,
  isSelected,
  onSelectContentClick
}) => (
  <a
    href={getInternalLinkUrl({ subpageId, contentUuid: uuid })}
    className={classNames('video-playlist__nav-item', className, {
      'video-playlist__nav-item--selected': isSelected
    })}
    role="tab"
    id={`video-${uuid}-tab`}
    aria-controls={`video-${uuid}`}
    aria-selected={isSelected ? 'true' : 'false'}
    tabIndex={isSelected ? null : '-1'}
    onClick={(e) => {
      e.preventDefault(); // Prevent page navigation
      onSelectContentClick(); // Update playlist state
    }}
    onKeyDown={(event)=> {
      // catch spacebar click
      if (event.keyCode === 32) {
        event.preventDefault();
        onSelectContentClick();
      }
    }}
  >
    <img
      alt={altText}
      src={thumbnail}
      className="video-playlist__nav-item-image"
    />

    <span className="video-playlist__nav-details">
      {
        isSelected &&
          <span className="video-playlist__nav-now-playing">
            Now Playing
          </span>
      }

      {
        title ?
          <span className="video-playlist__nav-item-title">
            { title }
          </span>
        :
          <VisuallyHiddenSpan className="video-playlist__nav-item-title">
            Video { playlistIdx + 1 }
          </VisuallyHiddenSpan>
      }
    </span>

    { children }
  </a>
);

const VideoPlaylistItem = (props)=> (
  <SiteViewerVersionComponentSelector>
    <VideoPlaylistItem_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <VideoPlaylistItem_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default VideoPlaylistItem;
